export { default } from './es/icons/FolderOpenFilled';